import styled, { css } from 'styled-components'

const you = css`
  .you {
    border-bottom: 0;
    text-shadow: 0 0 10px rgb(255 255 255 / 10%), 0 0 10px rgb(255 255 255 / 10%), 0 0 10px rgb(42 109 255 / 30%),
      0 0 10px rgb(42 109 255 / 30%), 0 0 10px rgb(42 109 255 / 30%), 0 0 10px rgb(42 109 255 / 30%),
      0 0 10px rgb(42 109 255 / 30%);
    border-bottom: 1px solid var(--bidding-table-cell-border);
  }
`
const otherUser = css`
  .otherUser {
    border-bottom: 1px solid var(--bidding-table-cell-border);
  }
`

export const TableContent = styled.div`
  display: contents;
  background: red;
  ${you}
  ${otherUser}
  &:hover {
    background: red;
  }
`
